import "./GetQuote.module.css";
import Header from "@/reusable_sections/Header";
import DriveYourGrowth from "./sections/DriveYourGrowth";
import PlanYourGathering from "./sections/PlanYourGathering";
import LocateOurStudio from "./sections/LocateOurStudio";
import Footer from "@/reusable_sections/Footer";
export default function GetQuotePage() {
  return <div>
      <Header />
      <DriveYourGrowth />
      <PlanYourGathering />
      <LocateOurStudio />
      <Footer />
    </div>;
}